import { render, staticRenderFns } from "./reject.vue?vue&type=template&id=793d3e4e&scoped=true"
import script from "./reject.vue?vue&type=script&lang=ts"
export * from "./reject.vue?vue&type=script&lang=ts"
import style0 from "./reject.vue?vue&type=style&index=0&id=793d3e4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793d3e4e",
  null
  
)

export default component.exports